import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { RELEASES } from "@/data";

export default function Music() {
  const [openId, setOpenId] = useState(null);
  const open = RELEASES.find((r) => r.id === openId);

  return (
    <div data-testid="music-grid" className="max-w-3xl mx-auto">
      <AnimatePresence>
        {open && (
          <motion.div key={open.id} initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.35 }} className="overflow-hidden mb-8 px-2">
            <iframe data-testid="spotify-embed-player" title={open.title}
              src={`https://open.spotify.com/embed/${open.kind}/${open.id}?utm_source=generator&theme=0`}
              width="100%" height="152" frameBorder="0" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" className="block" />
          </motion.div>
        )}
      </AnimatePresence>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-10 px-2">
        {RELEASES.map((r, i) => (
          <button key={r.id} onClick={() => setOpenId(openId === r.id ? null : r.id)} data-testid={`release-${i}`}
            className="group text-left flex flex-col items-start self-start">
            <div className="relative w-[82%]">
              <div className="vinyl absolute top-[4%] left-[26%] w-[92%] aspect-square transition-transform duration-500 group-hover:translate-x-3" />
              <img src={r.art} alt={r.title} loading="lazy" className="relative w-full aspect-square object-cover shadow-[0_0_0_2px_#fff]" />
            </div>
            <p className="mt-3 text-[#6b6f76] text-sm sm:text-base">{r.type}</p>
            <p className={`text-xl sm:text-2xl font-light leading-tight transition-colors duration-300 ${openId === r.id ? "text-white underline underline-offset-4" : "text-[#e6e8eb]"}`}>{r.title}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
